import React from "react";
import { Table, Space, Tooltip, message } from "antd";
import { limitWords, handlePdfDownload } from "../../utils/utils";
import SaveOutlinedIcon from "../icons/SaveOutlinedIcon";
import DownloadOutlinedIcon from "../icons/DownloadOutlineIcon";
import DeleteOutlinedIcon from "../icons/DeleteOutlineIcon";
// import SaveOutlinedIcon from "../icons/SaveOutlinedIcon";

export default function ClauseTable({
    data,
    isMaster = false,
    onDelete,
    onSaveAs,
}) {
    const columns = [
        {
            title: "Created By",
            dataIndex: "created_by",
            render: (text) => (
                <Tooltip title={text}>
                    <div
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {limitWords(text, 6)}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: "Clause name",
            dataIndex: "clause_name",
            render: (text) => (
                <Tooltip title={text}>
                    <div
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {limitWords(text, 6)}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: "Implementation Instances",
            dataIndex: "implementation_instances",
            render: (text) => (
                <Tooltip title={text}>
                    <div
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {limitWords(text, isMaster ? 20 : 6)}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: "Description",
            dataIndex: "description",
            render: (text) => (
                <Tooltip title={text}>
                    <div
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {limitWords(text, 6)}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: "Download",
            dataIndex: "clause_file",
            render: (_, record) => (
                <Space>
                    <div onClick={() => handlePdfDownload(record.clause_file)}>
                        <DownloadOutlinedIcon />
                    </div>
                </Space>
            ),
        },
    ];

    if (isMaster) {
        columns.push({
            title: "Save As",
            dataIndex: "id",
            render: (_, record) => (
                <Space>
                    <div onClick={() => onSaveAs(record)}>
                        <SaveOutlinedIcon />
                    </div>
                </Space>
            ),
        });
    } else {
        columns.push({
            title: "Delete",
            dataIndex: "id",
            render: (_, record) => (
                <Space>
                    <div onClick={() => onDelete(record.id)}>
                        <DeleteOutlinedIcon />
                    </div>
                </Space>
            ),
        });
    }

    return (
        <Table
            dataSource={data}
            columns={columns}
            pagination={true}
            bordered
            size="small"
            className="mb-4 template-table text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
            scroll={{ x: "max-content" }}
        />
    );
}
